import script from "./DeptEmp.vue?vue&type=script&setup=true&lang=js"
export * from "./DeptEmp.vue?vue&type=script&setup=true&lang=js"

import "./DeptEmp.vue?vue&type=style&index=0&id=b28bbd08&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b28bbd08"]])

export default __exports__